<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <section id="meters">
            <div class="card">
                <div class="row mt-1 mb-1">
                    <div class="col-md-6 col-12">
                        <div class="d-flex justify-content-between align-items-center m-1">
                            &nbsp;
                        </div>
                    </div>
                    <div class="col-md-6 col-12 d-flex justify-content-start justify-content-md-end">
                      <div class="d-flex align-items-center justify-content-end pr-1 pb-1 pb-md-0">
                        <a class="btn btn-primary ml-1" rippleEffect routerLink="/meters/add">
                        <i data-feather="plus" class="d-sm-none d-inline-block mr-0 mr-sm-1"></i
                        ><span class="d-none d-sm-inline-block">Home</span>
                        </a>
                      </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
  </div>
  
